import React from 'react';
import { Typography, Alert, Link } from '@one-thd/sui-atomic-components';
export var UserInviteAlert = function (_a) {
    var handleResendInviteLink = _a.handleResendInviteLink, alertStatus = _a.alertStatus, inviteStatus = _a.inviteStatus;
    var alertText = inviteStatus === 'pending' ? 'Invite Pending Acceptance' : 'Invite Expired';
    return (React.createElement("div", { className: "-sui-mb-4" },
        React.createElement(Alert, { status: alertStatus },
            React.createElement("div", null,
                React.createElement(Typography, { paragraph: true }, alertText),
                React.createElement(Link, { onClick: handleResendInviteLink, component: "button" }, "Resend Invite")))));
};
